<template>
  <div class="lms-wrapper-two">
    <student-nav @route-changed="toggleNavbar(false)" />

    <div class="lms-content">
      <student-header
        @toggle-navbar="toggleNavbar($event)"
        :navbarmode.sync="navbarMode"
      />

      <div
        class="lms-content-body container"
        style="bottom: 0; height: calc(100vh - 80px)"
      >
        <vue-custom-scrollbar
          :style="`height: ${getScrollHeight()}`"
          class="pd-10 bg-white rounded"
        >
          <table
            class="table table-striped table-hover table-sm table-responsive wd-100p"
          >
            <thead>
              <tr>
                <th scope="col" class="wd-50">Д/д</th>
                <th scope="col">Аялал</th>
                <th scope="col">Үүрэг даалгавар</th>
                <th scope="col">Огноо</th>
                <th scope="col">Хавсралт</th>
                <th scope="col">Даалгасан</th>
                <th scope="col">Хэнд</th>
              </tr>
            </thead>
            <tbody v-if="tasks.length">
              <tr
                @click="showTask(t)"
                v-for="(t, i) in tasks"
                :key="i"
                :class="`${t.isCompleted ? 'bg-success text-white' : ''}`"
                role="button"
              >
                <th scope="row" class="tx-color-03">{{ i + 1 }}</th>
                <td class="font-weight-bolder">{{ t.organizationTask.task }}</td>
                <td>
                  {{ t.task }}
                  <span v-if="t.organizationTask != null">
                    / {{ t.organizationTask.task }}</span
                  >
                </td>

                <td class="tx-color-03">
                  {{ t.d1 | moment("YYYY.MM.DD") }}
                  <!-- <sup>{{ t.d1 | moment('HH:mm') }}</sup> -->
                </td>
                <td class="tx-color-03">
                  <div v-if="t.defaultAttachmentId != null && t.defaultAttachmentId > 0">
                    <a
                      role="button"
                      @click.stop="showFile(t.defaultAttachmentId)"
                      class="btn btn-xs btn-primary"
                    >
                      <feather type="paperclip" class="mg-r-5"></feather>
                      харах
                    </a>
                  </div>
                </td>
                <td>{{ t.user.fullName }}</td>
                <td>
                  <ul v-if="t.sharedUsers.length>0 && t.sharedUsers.length<=3">
                    <li v-for="(u,ui) in t.sharedUsers.filter(x=>!x.isOwner)" :key="ui">{{ u.fullName }}</li>
                  </ul>
                  <div v-else-if="t.sharedUsers.length>3">
                    {{t.sharedUsers.length}}
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-else-if="isLoading">
              <tr>
                <td colspan="5" class="wd-100p">
                  <div class="container d-flex justify-content-center ht-100p">
                    <div
                      class="mx-wd-300 wd-sm-450 ht-100p d-flex flex-column align-items-center justify-content-center pd-t-100"
                    >
                      <div class="wd-80p wd-sm-300 mg-b-15">
                        <img src="assets/svg/boxempty.svg" alt="" class="img-fluid" />
                      </div>
                      <h4 class="tx-20 tx-sm-24 text-muted">түр хүлээнэ үү</h4>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="5" class="wd-100p">
                  <div class="container d-flex justify-content-center ht-100p">
                    <div
                      class="mx-wd-300 wd-sm-450 ht-100p d-flex flex-column align-items-center justify-content-center pd-t-100"
                    >
                      <div class="wd-80p wd-sm-300 mg-b-15">
                        <img src="assets/svg/boxempty.svg" alt="" class="img-fluid" />
                      </div>
                      <h4 class="tx-20 tx-sm-24 text-muted">Мэдээлэл хоосон байна</h4>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </vue-custom-scrollbar>
      </div>
    </div>

    <task-dialog
      v-if="tskDetail.id > 0"
      :id.sync="tskDetail.id"
      @on-task-close="tskDetail.id = 0"
      :detailSettingProp="{
        hideMainMenu: true,
        hideRightSidebar: false,
        boxSetting: { hideToolbar: true, listSetting: { disableDetail: true } },
      }"
    ></task-dialog>
  </div>
</template>
<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import vueCustomScrollbar from "vue-custom-scrollbar";

import { request } from "@/api/all";

export default {
  components: {
    vueCustomScrollbar,
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskDialog: () => ({
      component: import("@/components/task/detail/dialog.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      navbarMode: 0,
      filterModel: {
        task: "",
        systemFlag: null,
      },
      tasks: [],
      allCount: 0,
      isLoading: false,
      tskDetail: {
        id: 0,
      },
    };
  },
  mounted() {
    this.toggleBodyClass("addClass", "app-lms");
    require("@/assets/css/dynamic.lms.css");
    this.init();
    // this.initSearches();
  },
  destroyed() {
    //this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    toggleNavbar(shown) {
      if (this.navbarMode == 0) {
        this.navbarMode = 1;
        this.toggleBodyClass("addClass", "lms-sidebar-show");
      } else if (this.navbarMode == 1) {
        if (shown) {
          this.toggleBodyClass("addClass", "navbar-nav-show");
        } else {
          this.navbarMode = 0;
          this.toggleBodyClass("removeClass", "lms-sidebar-show");
        }
      }
    },
    init(force) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      this.isLoading = true;
      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: {
          skip: 0,
          size: 300,
          ot: 333,
          model: this.filterModel,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        this.isLoading = false;
        if (res != false) {
          // console.log(res);
          this.allCount = res.data.allCount;
          this.tasks = res.data.tasks;
        }
      });
    },
    showFile(id) {
      this.fileDialog.id = id;
      this.fileDialog.show = true;
    },
    showTask(t) {
      this.tskDetail.id = t.id;
    },
    getScrollHeight() {
      let mh = 130;
      if (screen.width <= 1024) {
        mh = 125;
      }
      return `calc(${window.innerHeight}px - ${mh}px) !important;`;
    },
  },
};
</script>
